import type { StaticImageData } from 'next/image'
import { TranslationKeys } from "locales/translationKeys"
import berneseImg from '../../../../../public/assets/home/bernese-we-feed-raw-box.webp'
import goldenImg from '../../../../../public/assets/home/golden-we-feed-raw-box.webp'
import poodleImg from '../../../../../public/assets/home/poodle-we-feed-raw-box.webp'
import tailWagsImg from '../../../../../public/assets/home/enjoy-the-tail-wags.webp'

const images: StaticImageData[] = [berneseImg, goldenImg, poodleImg, tailWagsImg]

type Result = {
    percent: TranslationKeys;
    benefit: TranslationKeys;
    image: StaticImageData;
    infoCard: {
        heading: TranslationKeys;
        body: TranslationKeys;
        imageAlt: TranslationKeys;
    };
}

export const results: Result[] = Array(4).fill('').map((_, i) => ({
    percent: `home:real-results.results.${i}.percent` as TranslationKeys,
    benefit: `home:real-results.results.${i}.benefit` as TranslationKeys,
    image: images[i],
    infoCard: {
        heading: `home:real-results.results.${i}.info-card.heading` as TranslationKeys,
        body: `home:real-results.results.${i}.info-card.body` as TranslationKeys,
        imageAlt: `home:real-results.results.${i}.info-card.imageAlt` as TranslationKeys,
    },
}))
